//	Purpose: Provides extensions to the boolean type.

globalThis.isFalsy = function (value: unknown): value is Falsy {
	return (
		value == null ||
		value === false ||
		value === 0 ||
		value === -0n ||
		value === 0n ||
		value === '' ||
		Number.isNaN(value) ||
		value === undefined ||
		(typeof value === 'string' && value.toLowerCase() === 'undefined')
	);
};

globalThis.isTruthy = function (value: unknown): value is Truthy {
	return !isFalsy(value);
};

globalThis.isTruthyOr = function <T>(value: unknown, orCheckFn: (value: unknown) => value is T): value is TruthyOr<T> {
	return isTruthy(value) || orCheckFn(value);
};

globalThis.isNullish = function (value: unknown): value is Nullish {
	return value == null;
};

globalThis.isNullable = function (value: unknown): value is Nullable<unknown> {
	return value == null;
};

globalThis.isNonNullable = function (value: unknown): value is NonNullable<unknown> {
	return value != null;
};

globalThis.is = function <T>(value: unknown, truthyValue: T, falsyValue?: T): boolean {
	if (falsyValue !== undefined && value === falsyValue) return false;
	return value === truthyValue;
};

export {};
